import { TableCell, TableRow, Stack, Collapse, Table } from '@mui/material';
import React, { useContext, useState } from 'react';
import { MdOutlineEdit } from 'react-icons/md';
import NewDialogPopup from '../../../../../../../components/Common/NewDialogPopup/NewDialogPopup';
import { LanguageContext } from '../../../../../../../libs/Context';
import { RiDeleteBinLine } from 'react-icons/ri';
import { IoMdArrowDropdown, IoMdArrowDropup } from 'react-icons/io';
import { catchErr, generateRandomUUID } from '../../../../../../../libs/HelperContent';
import { deletePolling } from '../../../../../../actions/meeting_actions';
import { toast } from 'react-toastify';

const letters = 'abcdefghijklmnopqrstuvwxyz'.split('');

const PollsTableBody = (props) =>
{
	const { eachItem, handleUpdate, handleDelete, viewOnly = false } = props;
	const [ delPoll, setDelPoll ] = useState<boolean>(false);
	const [ expand, setExpand ] = useState<boolean>(false);
	const { language } = useContext(LanguageContext);

	const handleExpand = () =>
	{
		setExpand(!expand);
	};
	const handleDeletePoll = () =>
	{
		setDelPoll(true);
	};

	const handleConfirmDelete = async () =>
	{
		const query = {
			pollingId : eachItem?._id
		};

		try
		{
			const res = await deletePolling(query);

			if (res?.status)
			{
				handleDelete(eachItem);
				setDelPoll(false);
				toast.success(language.pollDelete);
			}
			else
			{
				setDelPoll(false);
			}
		}
		catch (err)
		{
			// eslint-disable-next-line no-console
			console.log('================>', err);
			setDelPoll(false);
			catchErr(err);
		}
	};

	return (
		<>
			<TableRow >
				<TableCell
					sx={{
						overflow     : 'hidden',
						textOverflow : 'ellipsis',
						whiteSpace   : 'nowrap',
						maxWidth     : '300px'
					}} className='firstLetter'
				>
					{eachItem?.question}
				</TableCell>
				<TableCell>
					{eachItem?.questionType === 'multi' ? 'Multiple Choice' : 'Single Choice'}
				</TableCell>
				{!viewOnly && <TableCell >
					<Stack direction={'row'} spacing={2}>
						<MdOutlineEdit cursor={'pointer'} fontSize='var(--pixel22)' color='var(--txtColorBlackL)' onClick={(e) => handleUpdate(e, eachItem)}/>
						<RiDeleteBinLine cursor={'pointer'} fontSize='var(--pixel22)' color='var(--txtColorBlackL)' onClick={handleDeletePoll}/>
					</Stack>
				</TableCell>}
				<TableCell >
					<Stack direction={'row'} onClick={handleExpand}>
						{!expand
							?	<IoMdArrowDropdown cursor={'pointer'} fontSize='var(--pixel24)' />
							: <IoMdArrowDropup cursor={'pointer'} fontSize='var(--pixel24)'/>}

					</Stack>
				</TableCell>
			</TableRow>
			{eachItem?.options && (
				<TableRow sx={{ '& > *': { borderBottom: 'none' }, background: 'var(--whiteLight)' }}>
					<TableCell style={{ padding: 0 }} colSpan={6}>
						<Collapse in={expand} timeout='auto' unmountOnExit>
							<Table aria-label='poll'>
								{eachItem?.options?.map((item, index) => (
									<TableRow key={`list_${item?.id ?? item?._id ?? generateRandomUUID()}`}>
										<TableCell sx={{ minWidth: '150px' }}>{`${letters[index]}. ${item}`}</TableCell>
									</TableRow>
								))}
							</Table>
						</Collapse>
					</TableCell>
				</TableRow>
			)}
			{delPoll &&
				<NewDialogPopup
					open={delPoll}
					handleConfirm={() => setDelPoll(false)}
					closeCallBack={() => handleConfirmDelete()}
					type={language?.no}
					id={undefined}
					label={language.deletePollAlert}
					from='feedCreate'
					formatType={language?.yes}
				/>
			}
		</>
	);
};

export default PollsTableBody;
